export default "/react/logoExpecto-62c306c0.png";